import type { EstimationUnitType } from '@atlassian/jira-insights-common/src/common/types.tsx';
import type { ArisSprintCommitmentResponseSuccess } from '@atlassian/jira-insights-sprint-commitment/src/common/types.tsx';
import { getRecommendationStatus } from '@atlassian/jira-insights-sprint-commitment/src/common/utils.tsx';
import { transformSprintData } from '@atlassian/jira-insights-sprint-commitment/src/services/transformer/index.tsx';

export const getSprintEstimationTransformer =
	({
		estimationType,
		committed, // this is the committed value from the new sprint that is not yet started
	}: {
		committed: number;
		estimationType: EstimationUnitType;
	}) =>
	(apiResponse: ArisSprintCommitmentResponseSuccess) => {
		const formatSprint = transformSprintData(estimationType);
		const sprints = apiResponse.sprintCommitmentResult.values.map(formatSprint);

		const total = sprints.reduce((acc, sprint) => acc + sprint.completed, 0);
		const average = total / sprints.length;

		const { recommendationStatus, range } = getRecommendationStatus({
			average,
			value: committed,
			estimationUnit: estimationType,
		});

		return { total, average, sprints, recommendationStatus, range };
	};
